import { MoedaSaque, MOEDA_SAQUE_LABEL } from '../../../types/saque';

const localeByMoeda: Partial<Record<MoedaSaque, string>> = {
  [MoedaSaque.BRL]: 'pt-BR',
  [MoedaSaque.USD]: 'en-US',
  [MoedaSaque.EUR]: 'de-DE',
  [MoedaSaque.GBP]: 'en-GB',
  [MoedaSaque.JPY]: 'ja-JP',
};

export const formatMoney = (value: number, moeda: MoedaSaque): string => {
  const sigla = MOEDA_SAQUE_LABEL[moeda];
  const locale = localeByMoeda[moeda] ?? 'pt-BR';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: sigla,
    }).format(value);
  } catch {
    return `${sigla} ${value.toFixed(2)}`;
  }
};

export const formatDateTime = (iso: string): string => {
  try {
    const date = new Date(iso);
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch {
    return iso;
  }
};

export const formatDate = (iso: string): string => {
  try {
    const date = new Date(iso);
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  } catch {
    return iso;
  }
};
